import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from '@mui/material';
import { useAppSelector } from 'hooks/redux.hooks';
import _ from 'lodash';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { getFormattedNumber } from 'utils';

export default function PendingBalanceTable(props: { currencyId: string; pendingDataToShow: any }) {
  const theme = useTheme();
  const t = useAppSelector(selectTranslations);
  const prefixFields = 'page.dashboard.pending_balance.';
  const tableHeaders = [
    t(prefixFields + 'reference.text'),
    t(prefixFields + 'type.text'),
    t(prefixFields + 'amount.text'),
  ];
  const sortedData = props?.pendingDataToShow?.sort(
    (dataA, dataB) => new Date(dataB.date).setHours(0, 0, 0, 0) - new Date(dataA.date).setHours(0, 0, 0, 0)
  );

  return (
    <Box
      sx={{
        background: theme.palette.root.basicWhite,
        padding: '12px 14px 20px 14px',
        //position: 'absolute',
        zIndex: 1,
        //left: props.position + '%',
        //transform: 'translate(-50%, 0)',
        //top: '100%',
        borderRadius: '12px',
        boxShadow: '0px 4px 30px rgba(0, 0, 0, 0.25)',
        width: 'fit-content',
        '& .MuiTableCell-root': {
          paddingLeft: 0
        }
      }}
    >
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {tableHeaders?.map((header: string, index: number) => {
                return (
                  <TableCell colSpan={4} key={index}>
                    <Typography variant="body1">{header}</Typography>
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData?.map((data: any, index: number) => {
              return (
                <TableRow key={index}>
                  <TableCell colSpan={4}>
                    <Typography variant="body1">{data?.referenceNumber}</Typography>
                  </TableCell>
                  <TableCell colSpan={4}>
                    <Typography variant="body1">
                      {t(prefixFields + _.snakeCase(data?.transactionType) + '.text')}
                    </Typography>
                  </TableCell>
                  <TableCell colSpan={4}>
                    <Typography variant="body1">
                      {props.currencyId} {getFormattedNumber(data?.amount)}
                    </Typography>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
